// Deterministic 6-color palette for event pills. Backend does not yet persist
// a color field per event, so we hash the event id to keep cell colors stable
// across renders while staying close to the Figma palette.

export type EventColorKey = 'purple' | 'green' | 'blue' | 'orange' | 'peach' | 'red';

export const EVENT_COLOR_KEYS: EventColorKey[] = [
  'purple',
  'green',
  'blue',
  'orange',
  'peach',
  'red',
];

export const EVENT_COLOR_CLASSES: Record<
  EventColorKey,
  { pill: string; dot: string; swatch: string }
> = {
  purple: {
    pill: 'bg-primary-100 text-primary-700 dark:bg-primary-500/20 dark:text-primary-200',
    dot: 'bg-primary-500',
    swatch: 'bg-primary-500',
  },
  green: {
    pill: 'bg-success-100 text-success-700 dark:bg-success-500/20 dark:text-success-200',
    dot: 'bg-success-500',
    swatch: 'bg-success-500',
  },
  blue: {
    pill: 'bg-info-100 text-info-700 dark:bg-info-500/20 dark:text-info-200',
    dot: 'bg-info-500',
    swatch: 'bg-info-500',
  },
  orange: {
    pill: 'bg-warning-100 text-warning-700 dark:bg-warning-500/20 dark:text-warning-200',
    dot: 'bg-warning-500',
    swatch: 'bg-warning-500',
  },
  peach: {
    pill: 'bg-secondary-100 text-secondary-700 dark:bg-secondary-500/20 dark:text-secondary-200',
    dot: 'bg-secondary-500',
    swatch: 'bg-secondary-500',
  },
  red: {
    pill: 'bg-error-100 text-error-700 dark:bg-error-500/20 dark:text-error-200',
    dot: 'bg-error-500',
    swatch: 'bg-error-500',
  },
};

export const colorForEvent = (eventId: string): EventColorKey => {
  let hash = 0;
  for (let i = 0; i < eventId.length; i += 1) {
    hash = (hash * 31 + eventId.charCodeAt(i)) | 0;
  }
  const index = Math.abs(hash) % EVENT_COLOR_KEYS.length;
  return EVENT_COLOR_KEYS[index];
};
